import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumb from "Components/UI/Breadcrumb";
import PaginatedTable from "Components/Tables/PaginatedTable";
import useTableFilters from 'helpers/hooks/useTableFilters';
import Spinner from 'Components/UI/Spinner';
import convertDateFormat from 'Components/Date/DateFormat';
import { generateQueryParams } from 'helpers/queryParams';
import { deleteUser, getUsers } from 'helpers/API Calls/System & Settings/Users';
import DeleteModal from 'Components/Modals/DeleteModal';
import { Link } from 'react-router-dom';

const tableHead = [
  { id: 1, name: "#", isSortable: true, key: "id" },
  { id: 2, name: "Name", isSortable: true, key: "name" },
  { id: 3, name: "Email", isSortable: true, key: "email" },
  { id: 4, name: "User Type", isSortable: true, key: "user_type" },
  // { id: 5, name: "Email Verification", isSortable: false, key: "email_verified_at" },
  { id: 6, name: "Created", isSortable: true, key: "created_at" },
  { id: 7, name: "Updated", isSortable: true, key: "updated_at" },
  { id: 8, name: "Actions", isSortable: false, key: "actions" }
];

function Users() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [modal, setModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  
  const { filters, updateFilter } = useTableFilters();

  const fetchData = async () => {
    setIsLoading(true);
    const response = await getUsers(generateQueryParams(filters));
    if (response.success) {
      setData(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }
  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleClick = (item) => {
    setSelectedItem(item);
    setModal(true);
  };

  const handleConfirm = async () => {

    if (selectedItem) {
      const response = await deleteUser(selectedItem.id);
      if (response.success) {
        setModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onCloseClick = () => {
    setModal(false);
    setSelectedItem(null);
  };

  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Users"}]} />
        {isLoading ? (
          <div className="position-relative vh-100">
            <Spinner/>
          </div>
        ) : (
          <Card>
            <CardBody>
            <PaginatedTable
              tableHead={tableHead}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
              isAddButton={true}
              buttonText="Add New User"
              to="create"
              > 
              {data.length > 0 && data.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.user_type}</td>
                  {/* <td>
                    <span className={`badge badge-soft-${item.email_verified_at ? 'success' : 'danger'}`}>
                      {item.status === 1 ? 'Verified' : 'Not Verified'}
                    </span>
                  </td> */}
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.updated_at)}</td>
                  <td>
                    <div>
                      <Link to={`${item.id}/edit`} className="btn btn-primary btn-sm mx-1"><i className="bx bx-pencil"/></Link>
                      <button className="btn btn-danger btn-sm" onClick={() => handleClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={tableHead.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
    {modal &&
    <DeleteModal
      show={modal}
      onDeleteClick={handleConfirm}
      onCloseClick={onCloseClick}
      message={`"${selectedItem?.name}" user`}
    />}
    </>
  );
}

export default Users;
